export const ARTICLE_API = {
  key: "API_KEY_GET_ARTICLE_CONTENT",
  path: "/api/news-content",
};
